import React from 'react';
import PropTypes from 'prop-types';
import {Message} from 'epic-diesel-common';
//import classNames from 'classnames';
import {getMessage} from '../../common/Message';
import RadioBox from 'epic-diesel-form/src/components/form/RadioBox';
import signupStyles from '../../../pages/signup/SignUp.pcss';
import styles from './LegalAcknowledgementSection.pcss';

export default class LegalAcknowledgementSection extends React.Component {
    static propTypes = {
        messages: PropTypes.object,
        updateAgeAcknowledgment: PropTypes.func,
        age18Acknowledgment: PropTypes.bool,
        guardianAcknowledgment: PropTypes.bool
    };

    render() {
        const {messages, age18Acknowledgment, guardianAcknowledgment} = this.props;

        return (
            <div className={signupStyles.header}>
                <h2>
                    <Message code="epic.affiliate.signup.legal.header" />
                    {' *'}
                </h2>
                <p>
                    <Message code="epic.affiliate.signup.legal.text" />
                </p>

                <div className={styles.acknowledge}>
                    <RadioBox
                        name="ageAcknowledgment"
                        value={age18Acknowledgment}
                        onChange={this.props.updateAgeAcknowledgment}>
                        <Message code="epic.affiliate.signup.legal.acknowledge18" />
                    </RadioBox>
                    <RadioBox
                        name="guardianAcknowledgment"
                        validations={
                            guardianAcknowledgment || age18Acknowledgment ? null : 'checked'
                        }
                        validationError={getMessage(messages, 'ui.form.agreement.required')}
                        value={guardianAcknowledgment}
                        onChange={this.props.updateAgeAcknowledgment}>
                        <Message code="epic.affiliate.signup.legal.guardian" />
                    </RadioBox>
                </div>
            </div>
        );
    }
}
